import { Directive, Input, ElementRef, Renderer2, Inject } from '@angular/core';

import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';
import { GasObjectHelper } from '@cikrf/gas-utils/helpers';

import { GasPositioningPopup } from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.namespace';
import { GasDynamicPositioningPopupDirective } from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.directive';
import { GasPositioning } from '../../../utils/gas-positioning/gas-positioning.namespace';
import { GasPositioningService } from '../../../utils/gas-positioning/gas-positioning.service';
import { GasBrowserEventsService } from '../../../utils/gas-browser-event/gas-browser-events.service';
import { GAS_POSITIONING_CONFIG } from '../../../common/gas-dynamic-positioning-popup/gas-dynamic-positioning-popup.constant';
import { GasAutocompleteDropdownComponent } from './gas-autocomplete-dropdown.component';
import { GasAutocompleteComponent } from '../wrapper/gas-autocomplete.component';

@Directive({
  selector: '[gasAutocompleteDropdown]',
})
export class GasAutocompleteDropdownDirective extends GasDynamicPositioningPopupDirective<string | number,
GasAutocompleteDropdownComponent> {
  @Input('gasAutocompleteDropdown')
  public set setup(value: Omit<GasPositioningPopup.Config<GasAutocompleteDropdownComponent>, 'component'>) {
    this.config = {
      ...this.injectionConfig,
      ...{
        preferablePositions: [
          GasPositioning.Direction.Bottom,
          GasPositioning.Direction.Top,
        ],
        offset: 0,
        arrowWidth: 0,
      },
      ...GasObjectHelper.mergeDeep(value, {
        props: {
          gasAutocomplete: this.gasAutocomplete,
        },
      }),
      component: GasAutocompleteDropdownComponent,
      isInputOpen: true,
    };
    this.nativeDisabled = value?.disabled;
  }

  /** Без модификаторов доступа, ибо они указаны в расширяемом классе */
  constructor(
    el: ElementRef,
    gasDynamicComponentsService: GasDynamicComponentsService,
    gasPositioningService: GasPositioningService,
    gasBrowserEventsService: GasBrowserEventsService,
    render: Renderer2,
    @Inject(GAS_POSITIONING_CONFIG)
    private injectionConfig: GasPositioningPopup.Config<GasAutocompleteDropdownComponent>,
    private gasAutocomplete: GasAutocompleteComponent,
  ) {
    super(
      el,
      gasDynamicComponentsService,
      gasPositioningService,
      gasBrowserEventsService,
      render,
    );
  }
}
